import React from 'react';

import { Link } from 'gatsby';

import { styled } from '@mui/material';

import { Language } from '@mewa/types';
import { Tag } from '@mewa/ui';

import { slugifyByLang } from '../../../../libs/slugify';

type Props = {
  topics: {
    topic: string;
  }[];
  baseUrl: string;
  lang: Language;
  alignment?: 'center' | 'left';
};

export const Topics = ({
  topics,
  baseUrl,
  lang,
  alignment = 'center',
}: Props) => {
  return (
    <TopicWrapper alignment={alignment}>
      {topics.map((topic) => (
        <StyledTag
          key={topic.topic}
          link={{
            component: Link,
            props: { to: `${baseUrl}/${slugifyByLang(topic.topic, lang)}` },
          }}
          tagTheme="light"
        >
          {topic.topic}
        </StyledTag>
      ))}
    </TopicWrapper>
  );
};

const StyledTag = styled(Tag)({
  margin: '0 7px 15px 0',
});

const TopicWrapper = styled('div')(
  ({ alignment = 'center' }: { alignment?: string }) =>
    ({ theme }) => ({
      display: 'flex',
      flexWrap: 'wrap',

      [theme.breakpoints.up('sm')]: {
        justifyContent: alignment,
      },
    }),
);
